import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3003';

/**
 * Hook to automatically fetch Equipment Yard assets when component mounts
 * Uses the assets:query endpoint
 */
export function useEquipmentYardAssets(projectId) {
  const { token } = useAuth();
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!projectId || !token) {
      return;
    }

    const fetchAssets = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(
          `${API_BASE_URL}/api/assets/projects/${projectId}/assets`,
          {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          }
        );

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || `Failed to fetch assets: ${response.status}`);
        }

        const data = await response.json();
        setAssets(data.results || []);
      } catch (err) {
        console.error('[useEquipmentYardAssets] Error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAssets();
  }, [projectId, token]);

  return { assets, loading, error };
}
